import { useEffect, useRef } from 'react';
import { metrics } from '@atlassian/browser-metrics';

const JWM_SIDEBAR_SEGMENT_NAME = 'jwm.sidebar';

type MarkId = string;

export const RENDER_START_MARK: MarkId = `${JWM_SIDEBAR_SEGMENT_NAME}.render.start`;
export const RENDER_END_MARK: MarkId = `${JWM_SIDEBAR_SEGMENT_NAME}.render.end`;

const segment = metrics.pageSegmentLoad({
	key: JWM_SIDEBAR_SEGMENT_NAME,
	timings: [
		{
			key: 'tti',
			endMark: RENDER_END_MARK,
		},
	],
});

type Props = {
	id: MarkId;
};

export const PerformanceMark = ({ id }: Props) => {
	const startedRef = useRef(false);

	if (!__SERVER__ && !startedRef.current) {
		segment.startFromPageLoad();
		startedRef.current = true;
	}

	useEffect(() => segment.mark(id), [id]);

	return null;
};

export const PerformanceReport = () => {
	useEffect(() => {
		segment.stop();
	}, []);

	return null;
};
